module.exports = __webpack_public_path__ + "images/Tutorial_demo3.jpg";